import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../assets/css/global.css";

function Registry() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/auth/session`, { withCredentials: true })
      .then((res) => {
        if (res.data.user) {
          setUser(res.data.user);
        } else {
          navigate("/?error=Sessione Utente Inesistente");
        }
      })
      .catch(() => navigate("/?error=Sessione Utente Inesistente"));
  }, [navigate]);

  return (
    <main className="registry_container">
      <div className="dashboard_desk" id="driver_section">
        <div className="dashboard_search">
          <div className="dashboard_searchbar">
            <input type="text" id="search_drivers" placeholder="Cerca Corrieri..." />
            <button id="reset_drivers">Reset</button>
          </div>
          <div className="dashboard_list" id="drivers_list">
            <ul>
              <li data-id="1">Mario Rossi</li>
              <li data-id="2">Dario Bianchi</li>
              <li data-id="3">Giovanni Verdi</li>
              <li data-id="4">Lucio Neri</li>
              <li data-id="5">Cristiano Pavan</li>
              <li data-id="6">Edoardo Padoan</li>
              <li data-id="7">Aldo Baglio</li>
              <li data-id="8">Riccardo Zago</li>
              <li data-id="9">Denis Agresti</li>
              <li data-id="10">Giuseppe Leo</li>
              <li data-id="11">Manuel Turetta</li>
              <li data-id="12">Antonio Evangelisti</li>
            </ul>
          </div>
        </div>
        <div className="dashboard_details" id="details_drivers">
          <div className="dashboard_box">
            <ul>
              <li>Nominativo:</li>
              <li>Selezionare un Autista...</li>
              <li>Matricola:</li>
              <li>Selezionare un Autista...</li>
              <li>Contatto:</li>
              <li>Selezionare un Autista...</li>
              <li>Codice Patente:</li>
              <li>Selezionare un Autista...</li>
              <li>Tipo Patente:</li>
              <li>Selezionare un Autista...</li>
              <li>Scadenza Patente:</li>
              <li>Selezionare un Autista...</li>
            </ul>
          </div>
          <div className="dashboard_box">
            <img src={`${process.env.PUBLIC_URL}/images/svg/driver_profile_null.svg`} alt="Profilo Autista" />
            <button id="driver_registry">Anagrafica</button>
            <button id="driver_documents">Documenti</button>
            <button id="driver_attendance">Presenze</button>
            <button id="driver_connect">Associa</button>
          </div>
          <div className="dashboard_box">
            <ul>
              <li>Tipo Contratto:</li>
              <li>Selezionare un Autista...</li>
              <li>Scadenza Contratto:</li>
              <li>Selezionare un Autista...</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="dashboard_desk" id="vehicle_section">
        <div className="dashboard_search">
          <div className="dashboard_searchbar">
            <input type="text" id="search_vehicles" placeholder="Cerca furgoni..." />
            <button id="reset_vehicles">Reset</button>
          </div>
          <div className="dashboard_list" id="vehicles_list">
            <ul>
              <li data-id="13">ER456TE - Fiat Ducato</li>
              <li data-id="14">ER565GF - Fiat Ducato</li>
              <li data-id="15">EF975TT - Fiat Doblò</li>
              <li data-id="16">FF345RF - Fiat Ducato</li>
              <li data-id="17">FG278GF - Renault Kangoo Van</li>
              <li data-id="18">ER260EG - Iveco Daily</li>
              <li data-id="19">FG985CG - Mercedes eSprinter</li>
              <li data-id="20">BR270SR - Opel Vivaro</li>
              <li data-id="21">AT224PB - Citroe Jumper</li>
              <li data-id="22">GA996RV - Ford Ranger</li>
              <li data-id="23">GB168CC - Ford Transit</li>
              <li data-id="24">CF009FR - Renault Kangoo Van</li>
            </ul>
          </div>
        </div>
        <div className="dashboard_details" id="details_vehicles">
          <div className="dashboard_box">
            <ul>
              <li>Targa:</li>
              <li>Selezionare un Veicolo...</li>
              <li>Marca:</li>
              <li>Selezionare un Veicolo...</li>
              <li>Modello:</li>
              <li>Selezionare un Veicolo...</li>
              <li>Km Registrati:</li>
              <li>Selezionare un Veicolo...</li>
              <li>Carburante Registrato:</li>
              <li>Selezionare un Veicolo...</li>
              <li>Pneumatici:</li>
              <li>Selezionare un Veicolo...</li>
            </ul>
          </div>
          <div className="dashboard_box">
            <img src={`${process.env.PUBLIC_URL}/images/svg/vehicle_profile_null.svg`} alt="Profilo Veicolo" />
            <button id="vehicle_registry">Anagrafica</button>
            <button id="vehicle_attachments">Allegati</button>
            <button id="vehicle_workshop">Officina</button>
            <button id="vehicle_connect">Associa</button>
          </div>
          <div className="dashboard_box">
            <ul>
              <li>Scadenza Revisione:</li>
              <li>Selezionare un Veicolo...</li>
              <li>Scadenza Tagliando:</li>
              <li>Selezionare un Veicolo...</li>
            </ul>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Registry;